export function pct(value: number | null | undefined, digits = 1): string {
  if (value == null) return "—";
  return `${(value * 100).toFixed(digits)}%`;
}

export function signedPct(value: number | null | undefined, digits = 1): string {
  if (value == null) return "—";
  const s = (value * 100).toFixed(digits);
  return `${value >= 0 ? "+" : ""}${s}%`;
}

export function num(value: number | null | undefined, digits = 2): string {
  if (value == null) return "—";
  return value.toFixed(digits);
}

export function money(value: number | null | undefined): string {
  if (value == null) return "—";
  return `$${value.toFixed(2)}`;
}

/** YYYYMMDD → MM/DD */
export function shortDate(yyyymmdd: string): string {
  if (yyyymmdd.length !== 8) return yyyymmdd;
  return `${yyyymmdd.slice(4, 6)}/${yyyymmdd.slice(6, 8)}`;
}

export function directionLabel(d: string): string {
  return { buy: "매수", sell: "매도", hold: "보류" }[d] ?? d;
}

export function sessionLabel(s: string): string {
  return (
    { premarket: "프리마켓", open: "개장", confirm: "확정", closed: "휴장" }[s] ?? s
  );
}

export function trendLabel(t: string): string {
  return { up: "상승", down: "하락", flat: "보합" }[t] ?? t;
}

export function marketLabel(m: string): string {
  return { US: "미국", KR: "국내" }[m] ?? m;
}

/** 순매수 수량/대금을 만·억 단위로 부호와 함께 축약(예: +1.2억, -3.4만). */
export function netAmount(value: number | null | undefined): string {
  if (value == null) return "—";
  const sign = value > 0 ? "+" : value < 0 ? "-" : "";
  const abs = Math.abs(value);
  if (abs >= 1e8) return `${sign}${(abs / 1e8).toFixed(1)}억`;
  if (abs >= 1e4) return `${sign}${(abs / 1e4).toFixed(1)}만`;
  return `${sign}${abs.toFixed(0)}`;
}

/** ISO-8601 문자열 → MM/DD (신호 이력 행) */
export function isoShortDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("ko-KR", { month: "2-digit", day: "2-digit" });
}

/** epoch ms → HH:MM:SS (마지막 갱신 시각 표시) */
export function clockTime(ms: number): string {
  // ko-KR 기본 포맷은 "21시 43분 51초" 로 길어 헤더에 맞지 않는다.
  return new Date(ms).toLocaleTimeString("ko-KR", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
}
